(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-cm-souq"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cm-pcg-add]');
    if (!button || button.disabled) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    const textEl = button.querySelector('[data-cm-pcg-add-text]');
    const originalText = textEl ? textEl.textContent.trim() : '';

    button.disabled = true;
    if (textEl) textEl.textContent = 'Adding...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then((response) => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(() => {
        if (textEl) textEl.textContent = 'Added';

        document.dispatchEvent(new CustomEvent('cart:refresh'));

        fetch(window.Shopify.routes.root + 'cart.js')
          .then((response) => response.json())
          .then((cart) => {
            document
              .querySelectorAll('.cm-cart-count, [data-cart-count], [data-cm-cart-count], .cart-count-bubble span')
              .forEach((badge) => {
                badge.textContent = cart.item_count;
              });
          })
          .catch(() => {});

        window.setTimeout(() => {
          if (textEl) textEl.textContent = originalText;
          button.disabled = false;
        }, 1200);
      })
      .catch(() => {
        if (textEl) textEl.textContent = 'Try Again';

        window.setTimeout(() => {
          if (textEl) textEl.textContent = originalText;
          button.disabled = false;
        }, 1500);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
